import { useState } from 'react';
import { useVirtualKeyboardHeightContext } from '../../../utils/keyboard/VirtualKeyboardHeightContext';
import { getAdjustedToolbarGridSize } from '../utils/toolbarToolListCollapseUtils';

const TOOLBAR_WIDTHS = {
    large: 72,
    medium: 63,
    small: 63,
} as const;

const TRASH_TOOL_HEIGHT_GU = 5;
const MORE_TOOL_HEIGHT_GU = 4;

export type ToolbarAvailableHeight = {
    toolbarHeight: number;
    toolBarWidth: number;
    availableHeight: number;
    adjustedGridSize: {
        size: number;
        breakpoint: number;
        name: string;
    };
    setToolbarHeightMeasurement: (height: number) => void;
};

const useToolbarSize = ({ gridSizeName }: { gridSizeName: string }): ToolbarAvailableHeight => {
    const [toolbarHeight, setToolbarHeightMeasurement] = useState(0);

    const virtualKeyboardHeight = useVirtualKeyboardHeightContext();

    // adjust the toolbar grid size based on the available height
    const adjustedGridSize = getAdjustedToolbarGridSize(gridSizeName, toolbarHeight);

    // If the virtual keyboard is open, we don't display the trash, but we do display the more tool
    // so we need to adjust the available height accordingly
    const trashHeight = adjustedGridSize.size * TRASH_TOOL_HEIGHT_GU;
    const moreToolHeight = adjustedGridSize.size * MORE_TOOL_HEIGHT_GU;
    const removedHeight = virtualKeyboardHeight > 0 ? moreToolHeight : moreToolHeight + trashHeight;

    const availableHeight = toolbarHeight - virtualKeyboardHeight - removedHeight;

    const toolBarWidth = TOOLBAR_WIDTHS[adjustedGridSize.name as keyof typeof TOOLBAR_WIDTHS];

    return {
        toolbarHeight,
        toolBarWidth,
        availableHeight,
        adjustedGridSize,
        setToolbarHeightMeasurement,
    };
};

export default useToolbarSize;
